import ApiService, { withLoading } from "@/api/api";

const LOADING_KEY = "fic";

export default class FICService {
    constructor() {
        this.resourceLI = "/v1/dispendios";
        this.resourceLB = "/v1/dispendios";
    }

    // LI (RDA) endpoints
    getPatentesRequeridas(empresaId, anoBase) {
        return withLoading(LOADING_KEY, () => ApiService.get(`${this.resourceLI}/${empresaId}/fic/patentes-requeridas`, {
            params: { ano_base: anoBase }
        }));
    }

    getPublicacoesProjetos(empresaId, anoBase) {
        return withLoading(LOADING_KEY, () => ApiService.get(`${this.resourceLI}/${empresaId}/fic/publicacoes-projetos`, {
            params: { ano_base: anoBase }
        }));
    }

    getListLI(empresaId, anoBase) {
        return withLoading(LOADING_KEY, () => ApiService.get(`${this.resourceLI}/${empresaId}/fic`, {
            params: { ano_base: anoBase }
        }));
    }

    saveLI(empresaId, data) {
        return withLoading(LOADING_KEY, () => ApiService.post(`${this.resourceLI}/${empresaId}/fic`, data));
    }

    updateLI(empresaId, ficId, data) {
        return withLoading(LOADING_KEY, () => ApiService.post(`${this.resourceLI}/${empresaId}/fic/${ficId}`, data));
    }

    deleteLI(empresaId, ficId) {
        return withLoading(LOADING_KEY, () => ApiService.delete(`${this.resourceLI}/${empresaId}/fic/${ficId}`));
    }

    calcularQuantidades(empresaId, anoBase) {
        return withLoading(LOADING_KEY, () => ApiService.get(`${this.resourceLI}/${empresaId}/fic/calcular-quantidades`, {
            params: { ano_base: anoBase }
        }));
    }

    travarLI(empresaId, ficId) {
        return withLoading(LOADING_KEY, () => ApiService.post(`${this.resourceLI}/${empresaId}/fic/${ficId}/travar`));
    }

    // LB (FORMS) endpoints
    getListLB(empresaId, anoBase) {
        return withLoading(LOADING_KEY, () => ApiService.get(`${this.resourceLB}/${empresaId}/forms/fic`, {
            params: { ano_base: anoBase }
        }));
    }

    saveLB(empresaId, data) {
        return withLoading(LOADING_KEY, () => ApiService.post(`${this.resourceLB}/${empresaId}/forms/fic`, data));
    }

    updateLB(empresaId, ficId, data) {
        return withLoading(LOADING_KEY, () => ApiService.post(`${this.resourceLB}/${empresaId}/forms/fic/${ficId}`, data));
    }

    deleteLB(empresaId, ficId) {
        return withLoading(LOADING_KEY, () => ApiService.delete(`${this.resourceLB}/${empresaId}/forms/fic/${ficId}`));
    }
}
